import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Token:"be0e9f44f0f437e484ac03c7af4fb04d",
    AppKey:"123456",
    UserId:"132456",
    interrogationStatus:0//0为正常问诊 1为续方刚进入fill页面 2为续方进来，进入fill页面后也进入过其他页面
  },
  mutations: {
    // 改变interrogationStatus的值
    changeInts(state,value){
      state.interrogationStatus = value
    }
  },
  actions: {

  }
})
